import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { Sections } from '../../Components/Containers/Section';
import { PageLoading } from '../../Components/Loading';
import BarPieTableChart from './Components/BarPieTableChart';
import { useStats } from '../../Data/Payments';
import { usePreference } from '../../Data/Preference';
import { selectableDateRanges } from '../../Data/DateRanges';
import TimeSeriesChart from './Components/TimeSeriesChart';

const Payments = () => {
    const [dateRange, setDateRange] = usePreference('reports:payments:dateRange', 'thisMonth');
    const [show, setShow] = usePreference('reports:payments:show', 'gross');
    const {isLoading, stats} = useStats(dateRange, true);

    return <>
        <TopBar left="/reports"
            title="Payments"
            dropdownOptions={[
                {
                    section: 'Show'
                },
                {
                    title: 'Count',
                    value: 'count',
                    onClick: () => setShow('count'),
                    icon: 'count' === show ? 'CircleCheck' : 'Circle',
                },
                {
                    title: 'Gross',
                    value: 'gross',
                    onClick: () => setShow('gross'),
                    icon: 'gross' === show ? 'CircleCheck' : 'Circle',
                },
                {
                    title: 'Net',
                    value: 'net',
                    onClick: () => setShow('net'),
                    icon: 'net' === show ? 'CircleCheck' : 'Circle',
                },
                {
                    section: 'Date Range'
                },
                ...selectableDateRanges.map(r => ({
                    title: r.label,
                    value: r.value,
                    onClick: () => setDateRange(r.value),
                    icon: r.value === dateRange ? 'CircleCheck' : 'Circle',
                }))
            ]}
        />
        <Page>
            {(stats && !isLoading) ? <Inner {...{stats, show}} /> : <PageLoading />}
        </Page>
    </>
}

const Inner = ({stats, show}) => {
    const title = show === 'count' ? 'Count' : `Total (${show})`;
    const dataType = show === 'count' ? 'number' : 'currency';

    return <Sections>

        <TimeSeriesChart title="Payments over time"
            subtitle={`${title} of payments over time`}
            dataLabel="Payments"
            data={stats.overTime.map(s => ({label: s.date, value: s[show]}))}
            dataType={dataType}
        />

        <BarPieTableChart title="Payment Statuses"
            dataLabel="Payments"
            groupingLabel="Status"
            subtitle={`${title} by payment status`}
            labelValueData={stats.statuses.map(s => ({label: s.status, value: s[show]}))}
            dataType={dataType}
            defaultType="Pie"
        />
        <BarPieTableChart title="Payment Methods"
            dataLabel="Payments"
            groupingLabel="Payment Method"
            subtitle={`${title} by payment method`}
            labelValueData={stats.paymentMethods.map(s => ({label: s.paymentMethod, value: s[show]}))}
            dataType={dataType}
            defaultType="Pie"
        />

    </Sections>
}


export default Payments;
